/**
 * File: aria-list.js
 *
 * Import and initialize functions for skip to content functionality
 */

 export default {
	content: document.querySelector('.content_wrap > .content'),
	init() {
		if (this.content) {
			this.render();
		}
	},
	render() {
		const { content } = this;
		const button = document.querySelector('#pojo-a11y-skip-content');

		content.id = "content";
		if (button !== null) {
			button.setAttribute('tabindex','0');
		}
	},
  };
